import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '如何预约新加坡幸福缘的按摩服务？',
  answer: '您可以通过我们的Telegram频道或官方网站直接预约。我们提供24小时在线客服，随时为您安排最合适的技师和服务时间，确保您的预约流程简单快捷。'
}, {
  question: '幸福缘提供哪些按摩服务？',
  answer: '我们提供全方位的专业按摩服务，包括精油按摩、泰式按摩、深层组织按摩、足部按摩以及高端伴游服务等，满足您不同的放松与减压需求。'
}, {
  question: '服务时间是什么？',
  answer: '我们提供24小时全天候服务（24/7）。无论您是白天需要放松，还是深夜需要缓解疲劳，我们的专业团队随时待命，为您提供优质服务。'
}, {
  question: '技师是否经过专业培训？',
  answer: '是的，我们所有的技师均经过严格的筛选与系统培训，持有专业资格证书，拥有丰富的按摩经验，确保为您提供最正宗、最专业的按摩体验。'
}, {
  question: '是否支持上门按摩和酒店按摩？',
  answer: '完全支持。我们提供便捷的上门按摩（Outcall massage）和酒店按摩（Hotel massage）服务，让您在最熟悉、最舒适的环境中享受极致放松。'
}, {
  question: '如何保障客户隐私？',
  answer: '我们实行严格的保密制度，绝不泄露任何客户的个人信息。您的隐私安全是我们服务的最高准则，让您在享受服务时毫无后顾之忧。'
}, {
  question: '服务覆盖新加坡哪些区域？',
  answer: '我们的服务覆盖新加坡全岛，包括芽笼(Geylang)、乌节路(Orchard)、滨海湾(Marina Bay)、圣淘沙(Sentosa)、中央商务区(CBD)、裕廊(Jurong)、兀兰(Woodlands)等所有主要区域。'
}, {
  question: '价格如何？',
  answer: '我们提供透明且具有竞争力的价格体系。具体价格会根据您选择的服务项目、时长以及是否需要上门服务而有所不同，欢迎联系我们的24小时客服获取详细报价。'
}];
export function SEOContent() {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };
  return <>
      {/* Brand Story & Service Areas Section */}
      <section className="py-24 bg-[#1a1a2e] text-white border-t border-gray-800" data-id="element-147">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-148">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-149">
            <article data-id="element-150">
              <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 leading-tight" data-id="element-151">
                新加坡顶级<span className="text-[#c9a96e]" data-id="element-152">专业按摩</span>
                与伴游服务
              </h2>
              <div className="space-y-6 text-gray-300 leading-relaxed text-lg font-light" data-id="element-153">
                <p data-id="element-154">
                  新加坡幸福缘 (Singapore Happiness Connection)
                  致力于成为新加坡顶级的专业按摩与伴游服务平台。我们深知现代都市生活的压力，因此精心打造了一系列旨在舒缓身心、恢复活力的服务项目。
                </p>
                <p data-id="element-155">
                  无论您是寻求深层放松的<strong data-id="element-156">精油按摩</strong>{' '}
                  (Aromatherapy)、舒展筋骨的<strong data-id="element-157">泰式按摩</strong> (Thai
                  massage)，还是缓解肌肉酸痛的<strong data-id="element-158">深层组织按摩</strong>与
                  <strong data-id="element-159">足部按摩</strong>
                  ，我们的专业技师都能为您提供卓越的新加坡按摩服务 (Singapore
                  massage
                  service)。此外，我们还提供高端伴游服务，满足您的多样化社交需求。
                </p>
                <p data-id="element-160">
                  为了给您带来最大的便利，我们特别推出
                  <strong data-id="element-161">24小时按摩</strong>
                  服务，并全面支持上门按摩与酒店按摩，让您足不出户即可享受专业按摩的极致体验。
                </p>
              </div>
            </article>

            <article data-id="element-162">
              <h3 className="text-3xl md:text-4xl font-serif font-bold mb-6 leading-tight" data-id="element-163">
                全岛覆盖的<span className="text-[#c9a96e]" data-id="element-164">上门按摩</span>
                与酒店按摩
              </h3>
              <div className="space-y-6 text-gray-300 leading-relaxed text-lg font-light" data-id="element-165">
                <p data-id="element-166">
                  作为新加坡领先的按摩服务提供商，我们的服务网络遍布全岛。无论您身处繁华的乌节路
                  (Orchard)、商业核心区滨海湾 (Marina Bay) 和中央商务区
                  (CBD)，还是位于芽笼 (Geylang)、圣淘沙 (Sentosa)、裕廊 (Jurong)
                  或兀兰 (Woodlands)，我们都能迅速响应您的需求。
                </p>
                <p data-id="element-167">
                  我们的<strong data-id="element-168">上门按摩</strong> (Outcall massage) 和
                  <strong data-id="element-169">酒店按摩</strong> (Hotel massage)
                  服务专为追求高效与私密性的客户设计。只需一个预约，专业的技师便会携带全套设备准时抵达您的指定地点，为您开启一段专属的新加坡按摩
                  (Singapore massage) 放松之旅。
                </p>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-24 bg-[#faf7f2]" data-id="element-170">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
          <div className="text-center mb-16" data-id="element-172">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#1a1a2e] mb-4" data-id="element-173">
              常见问题
            </h2>
            <p className="text-[#c9a96e] uppercase tracking-widest font-medium" data-id="element-174">
              Frequently Asked Questions
            </p>
            <div className="w-24 h-1 bg-[#c9a96e] mx-auto mt-6" data-id="element-175" />
          </div>

          <div className="space-y-4" data-id="element-176">
            {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-100 rounded-sm shadow-sm overflow-hidden" data-id="element-177">
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-gray-50 transition-colors" data-id="element-178">
                  <span className="font-bold text-[#1a1a2e] text-lg pr-8" data-id="element-179">
                    {faq.question}
                  </span>
                  <ChevronDown className={`text-[#c9a96e] transform transition-transform duration-300 flex-shrink-0 ${openFaqIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-180" />
                </button>
                <AnimatePresence data-id="element-181">
                  {openFaqIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-182">
                      <div className="px-6 pb-5 text-gray-600 leading-relaxed border-t border-gray-50 pt-4" data-id="element-183">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}